// Dev environment for Lead variant — ECS deployment
export const environment = {
  production: true,
  apiUrl: 'https://api.omni.dev.barkani.com',
  companyId: 'cmp_8048562',
  variant: 'lead',
  title: 'Lead the Way',
  features: {
    callPlan: true
  },
  routes: {
    thankYou: '/thanks'
  }
};
